import React from 'react'
import { Modal, Button } from 'react-bootstrap'

import * as scans from '../../../services/scan-service'

export default class DeleteScanModal extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.handleShow = this.handleShow.bind(this);
    this.handleHide = this.handleHide.bind(this);
    this.handleDelete = this.handleDelete.bind(this);

    this.state = {show: false}
  }

  handleShow() {
    this.setState({ show: true })
  }

  handleHide() {
    this.setState({ show: false })
  }

  handleDelete() {
    scans.deleteScan(this.props.info.id).then(() => {this.handleHide()
    this.props.reload()}
    )
  }

  render() {
    return (
      <div>
        <Button bsStyle="primary" className='delete-entry action-btn' onClick={this.handleShow}>
          {this.props.text}
        </Button>
        <Modal
          {...this.props}
          show={this.state.show}
          onHide={this.handleHide}
          dialogClassName="custom-modal"
          backdrop={false}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">
               Verwijderen scan {this.props.info.locationName} {this.props.info.organizationalUnitName}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Wilt u de gegevens van deze scan verwijderen?
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="primary" onClick={this.handleDelete}>Verwijderen</Button>
            <Button onClick={this.handleHide}>Annuleren</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ScanOverview/modal/deleteScan.js